import * as actionTypes from "./actionTypes";
import axios from "axios";
import endpoint from "../../utility/endpoints";
import router from "next/router";
import { sessionTimeOutCheck, checkExpiry } from "../global/actions";
import endpoints from "../../utility/endpoints";

export const getProductAction = ({currentPage,size,filter}) => {

  return async function (dispatch) {
    
    let authCheck = JSON.parse(localStorage.getItem("auth")).data;
    let expiryStatus = await checkExpiry(authCheck);
    if (expiryStatus) {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      return axios({
        method: "post",
        url: `${endpoint.baseUrl}/task/getProducts`,
        data:{
          "product_id":"All",
          "page":currentPage,
          "size":size,
          "cluster":filter['cluster']||"",
          "clusters_live":filter['clusters_live']||"",
          "catalog_products":filter['catalog_products']||"",
           "sub_area":filter['sub_area']||"",
	  "product_title": filter['product_title']||"",
      },
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      }).then((response) => {
        if (response.data.code == 200) {
          dispatch(
            saveBotsAction({
              data: response.data.data,
              filter: false,
              total: response?.data?.total
            })
          );
        } else if (response.data.code == 403) {
          localStorage.removeItem("auth");
          sessionStorage.clear();
          // router.push("/login");
          dispatch(sessionTimeOutCheck(true));
        } else {
          dispatch(getBotsFailed());
        }
      });
    } else {
      dispatch(sessionTimeOutCheck(true));
    }
  };
};

export const getFilterBotsAction = (botIndex, Filters) => {
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  return async function (dispatch) {
    let authCheck = JSON.parse(localStorage.getItem("auth")).data;
    let expiryStatus = await checkExpiry(authCheck);
       if (expiryStatus) {
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        return axios({
        method: "get",
        url: `${endpoint.baseUrl}/elastic/searchQuery`,
        params: { ...Filters, botIndex: botIndex },

        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      }).then((resp) => {
        if (resp.data.code == 200) {
          dispatch(
            saveBotsAction({
              data: resp.data.data,
              filter: true,
              botIndex: botIndex,
            })
          );
        } else if (resp.data.code == 403) {
          localStorage.removeItem("auth");
          sessionStorage.clear();
          // router.push("/login");
          dispatch(sessionTimeOutCheck(true));
        } else {
          dispatch(getBotsFailed());
        }
      });
    } else {
      dispatch(sessionTimeOutCheck(true));
    }
  };
};
export const getFilterListAction = () => {
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  return async function (dispatch) {
    let authCheck = JSON.parse(localStorage.getItem("auth")).data;
    let expiryStatus = await checkExpiry(authCheck);
       if (expiryStatus) {
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        return axios({
        method: "get",
        url: `${endpoint.baseUrl}/task/getProductFilters`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      }).then((resp) => {
        if (resp.data.code == 200) {
          dispatch(
            saveFilterListProd({data: resp.data.data})
          );
        } else if (resp.data.code == 403) {
          localStorage.removeItem("auth");
          sessionStorage.clear();
          // router.push("/login");
          dispatch(sessionTimeOutCheck(true));
        } else {
          dispatch(getBotsFailed());
        }
      });
    } else {
      dispatch(sessionTimeOutCheck(true));
    }
  };
};

export const getBotsFailed = () => {
  return {
    type: actionTypes.getBotsFailed,
  };
};

export const saveBotsAction = (payload) => {
  return {
    type: actionTypes.saveBotsActionType,
    payload: payload,
  };
};

// to save the bot that user clicked on

export const saveCurrentBot = (payload) => {
  //console.log("at action");
  return {
    type: actionTypes.saveCurrentBotActionType,
    payload: payload,
  };
};
export const saveFilterListProd = (payload) => {
  //console.log("at action");
  return {
    type: actionTypes.saveFilterListProdnType,
    payload: payload,
  };
};

export const currentBotEditedStateAction = (payload) => {
  //console.log(payload, "currentBotEditedState");
  return {
    type: actionTypes.editCurrentBotActionType,
    payload: payload,
  };
};

